import React from "react";
import {strukturPPID,Struktur } from "../../assets";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function StrukturPPID() {
  useDocumentTitle("Struktur PPID - BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="profil" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Profil / Struktur PPID" />
          <div className="page-title-wrapper">
            <div className="page-title">Struktur PPID</div>
          </div>
          <div className="so-image-wrapper">
         
			<img src={strukturPPID} className="so-image"></img>
          </div>
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default StrukturPPID;
